<style src="../assets/css/rgpd.css" scoped></style>

<template>
<main class="container">
  <section class="hero">
    <h1>Mentions légales & RGPD</h1>
    <p>
      Cette page présente les informations légales obligatoires ainsi que la politique de protection
      des données personnelles du site <span class="hl">Asso-Refuge</span>.
    </p>

    <div class="cards">
      <div class="card">
        <h3>Éditeur</h3>
        <p>
          <span class="mono">[Ton nom / raison sociale]</span><br>
          Statut : <span class="mono">[Indépendant / AE / Asso]</span><br>
          Email : <span class="mono">lesrefuges.animalier@gmail.com </span>
        </p>
      </div>

      <div class="card">
        <h3>Hébergeur</h3>
        <p>
          <span class="mono">[Nom de l’hébergeur]</span><br>
          <span class="mono">[Adresse]</span><br>
          <span class="mono">[Site web]</span>
        </p>
      </div>

      <div class="card">
        <h3>Données</h3>
        <p>
          <span class="hl">Aucune publicité</span><br>
          <span class="hl">Aucune revente</span> de données<br>
          Droits RGPD : <span class="mono">lesrefuges.animalier@gmail.com </span>
        </p>
      </div>
    </div>
  </section>

  <section class="section">
    <h2>1) Éditeur du site</h2>
    <p>
      Nom du projet : <strong>Asso-Refuge</strong><br>
      Responsable de la publication : <strong>[Ton nom / raison sociale]</strong><br>
      Statut : <strong>[Indépendant / Auto-entrepreneur / Association]</strong><br>
      Email : <strong>lesrefuges.animalier@gmail.com </strong><br>
      Téléphone : <strong>[06 XX XX XX XX]</strong>
    </p>
  </section>

  <section class="section">
    <h2>2) Hébergement</h2>
    <p>
      Le site est hébergé par : <strong>[Nom de l’hébergeur]</strong><br>
      Adresse : <strong>[Adresse de l’hébergeur]</strong><br>
      Site web : <strong>[URL]</strong>
    </p>
  </section>

  <section class="section">
    <h2>3) Propriété intellectuelle</h2>
    <p>
      L’ensemble des contenus présents sur Asso-Refuge (textes, graphismes, logo, structure, base de données,
      contenus des pages) est protégé par le droit d’auteur et/ou les droits de propriété intellectuelle.
    </p>
    <p>
      Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle,
      sans autorisation préalable est interdite.
    </p>
  </section>

  <section class="section">
    <h2>4) Données personnelles (RGPD)</h2>
    <p>
      Asso-Refuge respecte la vie privée des utilisateurs et s’engage à protéger les données personnelles
      conformément au <span class="hl">Règlement Général sur la Protection des Données (RGPD)</span>.
    </p>

    <div class="info">
      Asso-Refuge est un projet <span class="hl">sans publicité</span> et les données personnelles ne sont
      <span class="hl">jamais vendues</span> ni cédées à des tiers.
    </div>
  </section>

  <section class="section">
    <h2>5) Données collectées</h2>
    <p>
      Asso-Refuge collecte uniquement les données strictement nécessaires :
    </p>
    <ul>
      <li>Données transmises volontairement lors d’un contact (email, téléphone, contenu du message)</li>
      <li>Données techniques minimales (logs serveur, sécurité, prévention des abus)</li>
    </ul>
    <p>
      À ce jour, le site ne propose pas de formulaire public. Les échanges se font principalement par email et téléphone.
    </p>
  </section>

  <section class="section">
    <h2>6) Finalités du traitement</h2>
    <ul>
      <li>Répondre aux demandes de contact</li>
      <li>Gérer les partenariats (refuges, sponsors)</li>
      <li>Assurer la sécurité et le bon fonctionnement du site</li>
    </ul>
  </section>

  <section class="section">
    <h2>7) Durée de conservation</h2>
    <p>
      Les données sont conservées uniquement pendant la durée nécessaire au traitement de la demande,
      puis supprimées ou archivées de manière limitée lorsque c’est nécessaire (ex : suivi partenariats).
    </p>
  </section>

  <section class="section">
    <h2>8) Droits des utilisateurs</h2>
    <p>
      Conformément à la réglementation, vous disposez des droits suivants :
    </p>
    <ul>
      <li>Droit d’accès</li>
      <li>Droit de rectification</li>
      <li>Droit d’opposition</li>
      <li>Droit à l’effacement</li>
      <li>Droit à la limitation du traitement</li>
    </ul>
    <p>
      Pour exercer ces droits, contactez : <strong>lesrefuges.animalier@gmail.com </strong>
    </p>
  </section>

  <section class="section">
    <h2>9) Cookies</h2>
    <p>
      Asso-Refuge n’utilise <span class="hl">aucun cookie publicitaire</span>. Des cookies strictement nécessaires
      (techniques) peuvent être utilisés pour assurer le bon fonctionnement du site (sécurité, session, etc.).
    </p>
  </section>

  <p class="note">
    Dernière mise à jour : <strong>[14/01/2026]</strong> •
    Cette page peut évoluer afin de rester conforme à la législation en vigueur.
  </p>
</main>

</template>